import Highlights from './Highlights.jsx';

export default Highlights;
